module.exports = __webpack_public_path__ + "img/adv_hj.693ede89.png";